import { User } from '../../type';
import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';

export const useUser = (userGuid: string): User | null => {
  return useCareTeamSelector(
    useCallback(
      (state) => {
        return state === 'LOADING' ? null : state.users[userGuid] ?? null;
      },
      [userGuid],
    ),
  );
};
